import React, { useState } from "react";
import classNames from "classnames";
import type { FieldConfig, FieldInputProps } from "formik";
import formStyles from "../../features/MainForm/Form.module.css";
import styles from "./Textarea.module.css";

interface TextAreaWithCounterProps {
  label: string;
  id: string;
  name: string;
  maxChars?: number;
  getFieldProps: (
    nameOrOptions: string | FieldConfig<any>
  ) => FieldInputProps<any>;
  touched?: { [key: string]: boolean | boolean[] };
  errors?: { [key: string]: string | string[] };
  variant?: "default" | "outlined" | "filled";
  placeHolder?: string;
}

export const TextareaField: React.FC<TextAreaWithCounterProps> = ({
  label,
  id,
  name,
  maxChars = 600,
  getFieldProps,
  touched,
  errors,
  variant = "default",
  placeHolder,
}) => {
  const [charCount, setCharCount] = useState<number>(0);
  const formikProps = getFieldProps(name);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(e.target.value.length);
    formikProps.onChange(e);
  };

  const textAreaClass = classNames(styles.textareaField, {
    [styles.textareaFieldOutlined]: variant === "outlined",
    [styles.textareaFieldFilled]: variant === "filled",
    [styles.textareaFieldError]: touched?.[name] && errors?.[name],
  });

  return (
    <div className={formStyles.formGroup}>
      <label htmlFor={id} className={formStyles.labelGroup}>
        {label}
      </label>
      <textarea
        id={id}
        {...formikProps}
        maxLength={maxChars}
        className={textAreaClass}
        onChange={handleChange}
        placeholder={placeHolder}
      />

      {touched?.[name] && errors?.[name] ? (
        <p className={formStyles.formError}>{errors[name]}</p>
      ) : (
        <div className={styles.charCounter}>
          {maxChars} / {charCount}
        </div>
      )}
    </div>
  );
};
